import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { checkedListEmptyMsg, noInternetMsg, saveFailedMsg, savemsg, saveWarningMsg, serverMsg } from "../../config/messageconstant";
import { mandatoryCheck } from "../../config/ValidationCheck";
import { CompOffJson } from "../../DynamicFormsJson/Transaction/compOff";
import {
    getLeaveYearBySalesTeamId,
} from "../../Slice/year.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { getDaySummaryBySalesTeam } from "../../Slice/salesExecutive.slice";
import dayjs from "dayjs";
import CompOffProcessTable from "./CompOffProcessTable";

class CompOffProcess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                leaveYearMasterDetail: this.props.leaveYearList?.carryForwardLeave,
            },
            formErrors: {},
            fieldData: {},
            salesTeamDataList: [],
            formErrorForDetails: {},
            allChecked: false,
        }
    }

    async componentDidMount() {
        const { getLeaveYearBySalesTeamId, showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            this.setState({ salesTeamDataList: [] });

            let salesTeamIdForCarryForward = this.props.params.id;

            showLoador({ loador: true });
            await getLeaveYearBySalesTeamId({ salesTeamId: salesTeamIdForCarryForward }).then(({ response, success }) => {
                if (!success) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                }
            });
            showLoador({ loador: false });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }


    componentWillReceiveProps(nextProps) {
        if (
            this.props.leaveYearList.carryForwardLeave !==
            nextProps.leaveYearList.carryForwardLeave
        ) {
            this.setState({
                dynamicMasterData: {
                    ...this.state.dynamicMasterData,
                    leaveYearMasterDetail: nextProps.leaveYearList.carryForwardLeave,
                },
            });
        }
    }

    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: CompOffJson.fieldMeta,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        return mandatoryCheckErrors.formValid;
    };

    submithandler = () => {
        const { salesTeamDataList } = this.state;
        const { showNotification, showLoador } = this.props;

        const filterDataList = salesTeamDataList.filter((row) => row.isChecked);

        if (filterDataList.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }

        const dataToSaveList =
            filterDataList.map((dataObj) => {
                return {
                    date:
                        dataObj.date !== null
                            ? dayjs(dataObj.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                            : "",
                    status: dataObj.attendance !== null ? dataObj.attendance : "",
                    isCompOffApplicable: dataObj.isMarkCompOff !== null ? (dataObj.isMarkCompOff == true ? 1 : 0) : 0,
                }
            });


        if (this.checkValidationOnSubmit()) {
            this.onSave(dataToSaveList);
        }
    }

    onSave = (dataToSaveList) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {

            let salesTeamId = this.props.params.id;

            swal({
                title: "Are you sure?",
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url: endpoint.salesExecutive + "/update-attendence-in-day-summary-of-sales-team?salesTeamId=" + salesTeamId,
                        postBody: dataToSaveList,
                    }).then(({ data, success }) => {
                        if (success) {
                            showNotification({ msg: savemsg });
                            this.props.navigate(-1);
                        } else {
                            showNotification({ msg: saveFailedMsg, severity: "error" });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;
        CompOffJson.fieldMeta.map((currentField) => {

            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };

    onSearch = async () => {
        const { getDaySummaryBySalesTeam, showLoador, showNotification } = this.props;
        const { fieldData } = this.state;

        if (this.checkValidationOnSubmit() && this.onSubmitCheck()) {

            let salesTeamId = this.props.params.id;
            let fromDate = dayjs(fieldData?.fromDate).format("DD-MM-YYYY")
            let toDate = dayjs(fieldData?.toDate).format("DD-MM-YYYY")

            showLoador({ loador: true });
            await getDaySummaryBySalesTeam({
                fromDate: fromDate,
                toDate: toDate,
                salesTeamId: salesTeamId
            }).then(({ response, success }) => {
                if (!success) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                } else {
                    this.setState({ salesTeamDataList: response });
                }
            });
            showLoador({ loador: false });

        }
    }


    handleAllCheckedClick = (e) => {
        const { salesTeamDataList } = this.state;
        this.setState({ allChecked: e.target.checked });
        let dataList = salesTeamDataList.map((dataObj) => {
            return {
                ...dataObj,
                isChecked: e.target.checked,
            };
        });
        this.setState({ salesTeamDataList: dataList });
    };


    handleCheckBoxClick = (e, id) => {
        const { salesTeamDataList } = this.state;
        let data = salesTeamDataList.map((dataObj) => {
            if (dataObj.id == id) {
                return {
                    ...dataObj,
                    isMarkCompOff: e.target.checked,
                };
            } else {
                return dataObj;
            }
        });
        this.setState({ salesTeamDataList: data });
    };


    handleAttendanceChange = (id, newStatus) => {
        const { salesTeamDataList } = this.state;
        const updatedList = salesTeamDataList.map(item => {
            if (item.id == id) {
                return { ...item, attendance: newStatus, isMarkCompOff: false };
            }
            return item;
        });
        this.setState({ salesTeamDataList: updatedList });
    };


    handleCheckBoxClickForSelectionRowData = (e, id) => {
        const { salesTeamDataList } = this.state;
        let data = salesTeamDataList.map((dataObj) => {
            if (dataObj.id == id) {
                return {
                    ...dataObj,
                    isChecked: e.target.checked,
                };
            } else {
                return dataObj;
            }
        });
        this.setState({ salesTeamDataList: data });
    };

    onSubmitCheck = () => {
        let formValid = true;
        const { fieldData } = this.state;

        let formErrors = {};
        CompOffJson.fieldMeta.forEach((currentField) => {
            if (currentField.onSubmit === "compare") {
                const onSubmitParameter = currentField.onSubmitParameter;
                if (onSubmitParameter) {
                    const compareWith = onSubmitParameter.split("-")[0].trim();
                    const compareCond = onSubmitParameter.split("-")[1].trim();
                    let isError = false;
                    let condErrorText = "";

                    let dataKeyValue = fieldData[currentField.dataKey];
                    let compareWithValue = fieldData[compareWith];
                    let fromDate = fieldData[currentField.dataKey];
                    let toDate = fieldData[compareWith];

                    if (fromDate && toDate) {
                        if (typeof fromDate === "string") {
                            const dateArr = fromDate?.split("-");

                            dataKeyValue = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
                        }
                        if (typeof toDate === "string") {
                            const dateArr = toDate?.split("-");

                            compareWithValue = new Date(
                                dateArr[0],
                                dateArr[1] - 1,
                                dateArr[2]
                            );
                        }
                        switch (compareCond) {
                            case "l":
                                if (!(dataKeyValue < compareWithValue)) {
                                    isError = true;
                                    condErrorText = "less than";
                                }

                                break;
                            case "le":
                                if (!(dataKeyValue <= compareWithValue)) {
                                    isError = true;
                                    condErrorText = "less than equal to";
                                }

                                break;
                            case "g":
                                if (!(dataKeyValue > compareWithValue)) {
                                    isError = true;
                                    condErrorText = "greater than";
                                }

                                break;
                            case "ge":
                                if (!(dataKeyValue >= compareWithValue)) {
                                    isError = true;
                                    condErrorText = "greater than equal to";
                                }

                                break;
                            case "eq":
                                if (!(dataKeyValue === compareWithValue)) {
                                    isError = true;
                                    condErrorText = "equal to";
                                }

                                break;
                            default:
                                break;
                        }

                        if (isError) {
                            const compareWithFieldLabel = CompOffJson.fieldMeta.filter(
                                (item) => item.dataKey === compareWith
                            )[0].label;
                            formValid = false;
                            formErrors = {
                                ...formErrors,
                                [currentField.dataKey]: {
                                    isError: true,
                                    errorText: `${currentField.label} should be ${condErrorText} ${compareWithFieldLabel}`,
                                },
                            };
                        }
                    }
                }
            }
        });
        this.setState({
            formErrors: formErrors,
        });
        return formValid;
    };

    render() {
        const {
            fieldData,
            formErrors,
            dynamicMasterData,
            salesTeamDataList,
            allChecked,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        showTitle={CompOffJson.showTitle}
                        screenTitle={CompOffJson.screenTitleForProcess}
                        fieldMeta={CompOffJson.fieldMeta}
                        apiBaseURL={CompOffJson.apiBaseURL}
                        formErrors={formErrors}
                        onFormSave={this.onSearch}
                        saveBtnText={"Search"}
                        showSaveBtn={true}
                        showSaveBtnMain={false}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        showBackToList={true}
                    />

                    <CompOffProcessTable
                        clickSubmitHandler={this.submithandler}
                        salesTeamDataList={salesTeamDataList}
                        handleCheckBoxClick={this.handleCheckBoxClick}
                        handleAttendanceChange={this.handleAttendanceChange}
                        handleAllCheckedClick={this.handleAllCheckedClick}
                        allChecked={allChecked}
                        handleCheckBoxClickForSelectionRowData={this.handleCheckBoxClickForSelectionRowData}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    leaveYearList: state.year,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getLeaveYearBySalesTeamId,
    getDaySummaryBySalesTeam,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CompOffProcess);
